import React from 'react'
import querystring from 'querystring'
import { compose } from 'redux'
import vtConfig from 'experiments/vtConfig'
import ExperimentsProvider from '@cred/react-experiments/provider'
import withReduxProvider from 'components/hocs/withReduxProvider'
import withApolloProvider from 'components/hocs/withApolloProvider'

const ONE_YEAR = 365 * 864e+5,
  getCookieOptions = () => ({
    expires: new Date(Date.now() + ONE_YEAR),
    path: '/',
    httpOnly: false,
    secure: true,
    sameSite: 'none',
  })

const withExperimentProvider = WrappedComponent => props => (
  <ExperimentsProvider
    config={vtConfig}
    url={window.location.href}
    queryParams={querystring.decode(window.location.search)}
    userAgent={window.navigator.userAgent}
    getCookieOptions={getCookieOptions}
  >
    <WrappedComponent {...props} />
  </ExperimentsProvider>
)

export default compose(withApolloProvider, withReduxProvider, withExperimentProvider)
